module.exports = /******/
function(modules) {
    /******/
    /******/
    // The require function
    /******/
    function __webpack_require__(moduleId) {
        /******/
        /******/
        // Check if module is in cache
        /******/
        if (installedModules[moduleId]) /******/
        return installedModules[moduleId].exports;
        /******/
        /******/
        // Create a new module (and put it into the cache)
        /******/
        var module = installedModules[moduleId] = {
            /******/
            exports: {},
            /******/
            id: moduleId,
            /******/
            loaded: !1
        };
        /******/
        /******/
        // Return the exports of the module
        /******/
        /******/
        /******/
        // Execute the module function
        /******/
        /******/
        /******/
        // Flag the module as loaded
        /******/
        return modules[moduleId].call(module.exports, module, module.exports, __webpack_require__), 
        module.loaded = !0, module.exports;
    }
    // webpackBootstrap
    /******/
    // The module cache
    /******/
    var installedModules = {};
    /******/
    /******/
    // Load entry module and return exports
    /******/
    /******/
    /******/
    /******/
    // expose the modules object (__webpack_modules__)
    /******/
    /******/
    /******/
    // expose the module cache
    /******/
    /******/
    /******/
    // __webpack_public_path__
    /******/
    return __webpack_require__.m = modules, __webpack_require__.c = installedModules, 
    __webpack_require__.p = "", __webpack_require__(0);
}([ /* 0 */
/***/
function(module, exports, __webpack_require__) {
    module.exports = __webpack_require__(5);
}, /* 1 */
, /* 2 */
, /* 3 */
, /* 4 */
, /* 5 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _defineProperty2 = __webpack_require__(6), _defineProperty3 = _interopRequireDefault(_defineProperty2), _getPrototypeOf = __webpack_require__(7), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(8), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(9), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(10), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(11), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(12), _react2 = _interopRequireDefault(_react), _reactDom = __webpack_require__(13), _reactDom2 = _interopRequireDefault(_reactDom), _styles = __webpack_require__(14), _styles2 = _interopRequireDefault(_styles), _layer = __webpack_require__(18), _layer2 = _interopRequireDefault(_layer), _droplistTrigger = __webpack_require__(19), _droplistTrigger2 = _interopRequireDefault(_droplistTrigger), _classnames = __webpack_require__(20), _classnames2 = _interopRequireDefault(_classnames), halfFocusRing = 1, numberOfVisibleItems = 9, DropdownList = function(_PureComponent) {
        function DropdownList() {
            var _ref, _temp, _this, _ret;
            (0, _classCallCheck3.default)(this, DropdownList);
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
            return _temp = _this = (0, _possibleConstructorReturn3.default)(this, (_ref = DropdownList.__proto__ || (0, 
            _getPrototypeOf2.default)(DropdownList)).call.apply(_ref, [ this ].concat(args))), 
            _this.componentDidMount = function() {
                _this.domItemsList && _this.focusFirstItem(), _this.props.shouldFitContainer && _this.dropContentRef && (_this.dropContentRef.style.width = _this.triggerRef.offsetWidth - 2 * halfFocusRing + "px"), 
                document.addEventListener("click", _this.handleClickOutside);
            }, _this.componentDidUpdate = function() {
                _this.props.isOpen && (_this.props.isKeyboardInteractionDisabled || _this.focusFirstItem(), 
                _this.props.shouldFitContainer && _this.dropContentRef && (_this.dropContentRef.style.width = _this.triggerRef.offsetWidth - 2 * halfFocusRing + "px"));
            }, _this.componentWillUnmount = function() {
                document.removeEventListener("click", _this.handleClickOutside);
            }, _this.setMaxHeight = function(dropDomRef) {
                var appearance = _this.props.appearance, maxHeight = _this.getMaxHeight(), height = maxHeight ? maxHeight + "px" : "none";
                dropDomRef.style.maxHeight = "tall" !== appearance ? height : "none";
            }, _this.getMaxHeight = function() {
                // When dropdown contains more than 9 elemens (droplist items, droplist groups),
                // it should have scroll and cut off half of the 10th item to indicate that there are more
                // items then are seen.
                var items = _this.dropContentRef.querySelectorAll('[data-role="droplistGroupHeading"], [data-role="droplistItem"]'), scrollThresholdItemIndex = Math.min(items.length, numberOfVisibleItems), scrollThresholdItem = items[scrollThresholdItemIndex - 1];
                if (!scrollThresholdItem) return null;
                // It really should be something like this.dropContentRef.lastChild.offsetBottom,
                // but since there is no offsetBottom method, it's just easier to do it like this
                // since the values are the same.
                var bottomPadding = _this.dropContentRef.firstChild.offsetTop;
                return scrollThresholdItemIndex < numberOfVisibleItems ? scrollThresholdItem.offsetTop + scrollThresholdItem.clientHeight + bottomPadding : scrollThresholdItem.offsetTop + scrollThresholdItem.clientHeight / 2;
            }, _this.getNextFocusable = function(indexItem, available) {
                var currentItem = void 0 === indexItem ? -1 : indexItem, latestAvailable = void 0 === available ? currentItem : available;
                return currentItem < _this.domItemsList.length - 1 ? (currentItem++, "true" !== _this.domItemsList[currentItem].getAttribute("aria-hidden") ? currentItem : _this.getNextFocusable(currentItem, latestAvailable)) : latestAvailable;
            }, _this.getPrevFocusable = function(indexItem, available) {
                var currentItem = indexItem, latestAvailable = void 0 === available ? currentItem : available;
                return currentItem > 0 ? (currentItem--, "true" !== _this.domItemsList[currentItem].getAttribute("aria-hidden") ? currentItem : _this.getPrevFocusable(currentItem, latestAvailable)) : latestAvailable || currentItem;
            }, _this.focusFirstItem = function() {
                "keydown" === _this.sourceOfIsOpen && _this.focusItem(_this.getNextFocusable());
            }, _this.focusNextItem = function() {
                _this.focusItem(_this.getNextFocusable(_this.focusedItem));
            }, _this.focusPreviousItem = function() {
                _this.focusItem(_this.getPrevFocusable(_this.focusedItem));
            }, _this.focusItem = function(index) {
                _this.focusedItem = index, _this.domItemsList[_this.focusedItem].focus();
            }, _this.isTargetChildItem = function(target) {
                return target && "droplistItem" === target.getAttribute("data-role") && _reactDom2.default.findDOMNode(_this).contains(target);
            }, _this.handleKeyDown = function(event) {
                if ("Escape" === event.key && _this.close({
                    event: event
                }), _this.props.isOpen && !_this.props.isKeyboardInteractionDisabled) if (_this.isTargetChildItem(event.target)) switch (event.key) {
                  case "ArrowUp":
                    event.preventDefault(), _this.focusPreviousItem();
                    break;

                  case "ArrowDown":
                    event.preventDefault(), _this.focusNextItem();
                    break;

                  case "Tab":
                    event.preventDefault(), _this.close({
                        event: event
                    });
                } else "ArrowDown" === event.key ? (_this.sourceOfIsOpen = "keydown", _this.focusFirstItem()) : "Tab" === event.key && _this.close({
                    event: event
                });
            }, _this.handleClickOutside = function(event) {
                if (_this.props.isOpen) {
                    var domNode = _reactDom2.default.findDOMNode(_this);
                    // eslint-disable-line react/no-find-dom-node
                    (!domNode || event.target instanceof Node && !domNode.contains(event.target)) && _this.close({
                        event: event
                    });
                }
            }, _this.handleTriggerActivation = function(attrs) {
                _this.toggle(attrs);
            }, _this.open = function(attrs) {
                _this.sourceOfIsOpen = attrs.source, _this.props.onOpenChange({
                    isOpen: !0,
                    event: attrs.event
                });
            }, _this.close = function(attrs) {
                _this.sourceOfIsOpen = null, _this.props.onOpenChange({
                    isOpen: !1,
                    event: attrs.event
                });
            }, _this.toggle = function(attrs) {
                _this.props.isKeyboardInteractionDisabled && "keydown" === attrs.source || (_this.props.isOpen ? _this.close(attrs) : _this.open(attrs));
            }, _ret = _temp, (0, _possibleConstructorReturn3.default)(_this, _ret);
        }
        // eslint-disable-line react/no-find-dom-node
        return (0, _inherits3.default)(DropdownList, _PureComponent), (0, _createClass3.default)(DropdownList, [ {
            key: "render",
            value: function() {
                var _this2 = this, props = this.props;
                // items' event delegation
                return _react2.default.createElement("div", {
                    // eslint-disable-line jsx-a11y/no-static-element-interactions
                    className: (0, _classnames2.default)([ _styles2.default.dropWrapper, (0, _defineProperty3.default)({}, _styles2.default.fitContainer, props.shouldFitContainer) ]),
                    onKeyDown: this.handleKeyDown
                }, _react2.default.createElement(_layer2.default, {
                    position: props.position,
                    offset: "0 4",
                    autoPosition: props.shouldFlip,
                    content: props.isOpen ? _react2.default.createElement("div", {
                        className: _styles2.default.dropContent,
                        "data-role": "droplistContent",
                        ref: function(_ref3) {
                            _ref3 && (_this2.dropContentRef = _ref3, _this2.domItemsList = _ref3.querySelectorAll('[data-role="droplistItem"]'), 
                            _this2.setMaxHeight(_ref3));
                        }
                    }, props.children) : null
                }, _react2.default.createElement("div", {
                    className: _styles2.default.dropTrigger,
                    ref: function(_ref4) {
                        return _this2.triggerRef = _ref4;
                    }
                }, _react2.default.createElement(_droplistTrigger2.default, {
                    isDisabled: props.isTriggerDisabled,
                    isNotTabbable: props.isTriggerNotTabbable,
                    isOpened: props.isOpen,
                    onActivate: this.handleTriggerActivation,
                    shouldFitContainer: props.shouldFitContainer
                }, props.trigger))));
            }
        } ]), DropdownList;
    }(_react.PureComponent);
    DropdownList.propTypes = {
        appearance: _react.PropTypes.oneOf([ "default", "tall" ]),
        children: _react.PropTypes.node,
        isOpen: _react.PropTypes.bool,
        shouldFitContainer: _react.PropTypes.bool,
        isKeyboardInteractionDisabled: _react.PropTypes.bool,
        isTriggerDisabled: _react.PropTypes.bool,
        isTriggerNotTabbable: _react.PropTypes.bool,
        listContext: _react.PropTypes.oneOf([ "menu" ]),
        onOpenChange: _react.PropTypes.func,
        position: _react.PropTypes.string,
        trigger: _react.PropTypes.node,
        shouldFlip: _react.PropTypes.bool
    }, DropdownList.defaultProps = {
        appearance: "default",
        position: "bottom left",
        isOpen: !1,
        shouldFitContainer: !1,
        isKeyboardInteractionDisabled: !1,
        isTriggerDisabled: !1,
        isTriggerNotTabbable: !1,
        listContext: "menu",
        onOpenChange: function() {},
        children: null,
        trigger: null,
        shouldFlip: !0
    }, exports.default = DropdownList;
}, /* 6 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/defineProperty");
}, /* 7 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/core-js/object/get-prototype-of");
}, /* 8 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/classCallCheck");
}, /* 9 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/createClass");
}, /* 10 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/possibleConstructorReturn");
}, /* 11 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/inherits");
}, /* 12 */
/***/
function(module, exports) {
    module.exports = require("react");
}, /* 13 */
/***/
function(module, exports) {
    module.exports = require("react-dom");
}, /* 14 */
/***/
function(module, exports, __webpack_require__) {
    // style-loader: Adds some css to the DOM by adding a <style> tag
    // load the styles
    var content = __webpack_require__(15);
    "string" == typeof content && (content = [ [ module.id, content, "" ] ]);
    // add the styles to the DOM
    __webpack_require__(17)(content, {});
    content.locals && (module.exports = content.locals);
}, /* 15 */
/***/
function(module, exports, __webpack_require__) {
    exports = module.exports = __webpack_require__(16)(), // imports
    // module
    exports.push([ module.id, "._1SLKjrUVbEkIcWt_GtqIWd{background:#fff;border-radius:3px;box-shadow:0 4px 8px -2px rgba(9,30,66,.25),0 0 1px rgba(9,30,66,.31);box-sizing:border-box;overflow:auto;padding:8px 0}._1WOjWfE-btzXyVyhFRfuaS{display:-webkit-box;display:flex;width:100%}._3OQE5wLIANDtG47b5FaI9e{display:-webkit-inline-box;display:inline-flex}._2-JZNxEUJhEAgPAmJiUObL{display:block;-webkit-box-flex:1;flex:1 1 auto}", "" ]), 
    // exports
    exports.locals = {
        dropContent: "_1SLKjrUVbEkIcWt_GtqIWd",
        dropContent: "_1SLKjrUVbEkIcWt_GtqIWd",
        dropTrigger: "_1WOjWfE-btzXyVyhFRfuaS",
        dropTrigger: "_1WOjWfE-btzXyVyhFRfuaS",
        dropWrapper: "_3OQE5wLIANDtG47b5FaI9e",
        dropWrapper: "_3OQE5wLIANDtG47b5FaI9e",
        fitContainer: "_2-JZNxEUJhEAgPAmJiUObL",
        fitContainer: "_2-JZNxEUJhEAgPAmJiUObL"
    };
}, /* 16 */
/***/
function(module, exports) {
    /*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
    // css base code, injected by the css-loader
    module.exports = function() {
        var list = [];
        // return the list of modules as css string
        // import a list of modules into the list
        return list.toString = function() {
            for (var result = [], i = 0; i < this.length; i++) {
                var item = this[i];
                item[2] ? result.push("@media " + item[2] + "{" + item[1] + "}") : result.push(item[1]);
            }
            return result.join("");
        }, list.i = function(modules, mediaQuery) {
            "string" == typeof modules && (modules = [ [ null, modules, "" ] ]);
            for (var alreadyImportedModules = {}, i = 0; i < this.length; i++) {
                var id = this[i][0];
                "number" == typeof id && (alreadyImportedModules[id] = !0);
            }
            for (i = 0; i < modules.length; i++) {
                var item = modules[i];
                // skip already imported module
                // this implementation is not 100% perfect for weird media query combinations
                //  when a module is imported multiple times with different media queries.
                //  I hope this will never occur (Hey this way we have smaller bundles)
                "number" == typeof item[0] && alreadyImportedModules[item[0]] || (mediaQuery && !item[2] ? item[2] = mediaQuery : mediaQuery && (item[2] = "(" + item[2] + ") and (" + mediaQuery + ")"), 
                list.push(item));
            }
        }, list;
    };
}, /* 17 */
/***/
function(module, exports, __webpack_require__) {
    function addStylesToDom(styles, options) {
        for (var i = 0; i < styles.length; i++) {
            var item = styles[i], domStyle = stylesInDom[item.id];
            if (domStyle) {
                domStyle.refs++;
                for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j](item.parts[j]);
                for (;j < item.parts.length; j++) domStyle.parts.push(addStyle(item.parts[j], options));
            } else {
                for (var parts = [], j = 0; j < item.parts.length; j++) parts.push(addStyle(item.parts[j], options));
                stylesInDom[item.id] = {
                    id: item.id,
                    refs: 1,
                    parts: parts
                };
            }
        }
    }
    function listToStyles(list) {
        for (var styles = [], newStyles = {}, i = 0; i < list.length; i++) {
            var item = list[i], id = item[0], css = item[1], media = item[2], sourceMap = item[3], part = {
                css: css,
                media: media,
                sourceMap: sourceMap
            };
            newStyles[id] ? newStyles[id].parts.push(part) : styles.push(newStyles[id] = {
                id: id,
                parts: [ part ]
            });
        }
        return styles;
    }
    function insertStyleElement(options, styleElement) {
        var head = getHeadElement(), lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
        if ("top" === options.insertAt) lastStyleElementInsertedAtTop ? lastStyleElementInsertedAtTop.nextSibling ? head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling) : head.appendChild(styleElement) : head.insertBefore(styleElement, head.firstChild), 
        styleElementsInsertedAtTop.push(styleElement); else {
            if ("bottom" !== options.insertAt) throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
            head.appendChild(styleElement);
        }
    }
    function removeStyleElement(styleElement) {
        styleElement.parentNode.removeChild(styleElement);
        var idx = styleElementsInsertedAtTop.indexOf(styleElement);
        idx >= 0 && styleElementsInsertedAtTop.splice(idx, 1);
    }
    function createStyleElement(options) {
        var styleElement = document.createElement("style");
        return styleElement.type = "text/css", insertStyleElement(options, styleElement), 
        styleElement;
    }
    function createLinkElement(options) {
        var linkElement = document.createElement("link");
        return linkElement.rel = "stylesheet", insertStyleElement(options, linkElement), 
        linkElement;
    }
    function addStyle(obj, options) {
        var styleElement, update, remove;
        if (options.singleton) {
            var styleIndex = singletonCounter++;
            styleElement = singletonElement || (singletonElement = createStyleElement(options)), 
            update = applyToSingletonTag.bind(null, styleElement, styleIndex, !1), remove = applyToSingletonTag.bind(null, styleElement, styleIndex, !0);
        } else obj.sourceMap && "function" == typeof URL && "function" == typeof URL.createObjectURL && "function" == typeof URL.revokeObjectURL && "function" == typeof Blob && "function" == typeof btoa ? (styleElement = createLinkElement(options), 
        update = updateLink.bind(null, styleElement), remove = function() {
            removeStyleElement(styleElement), styleElement.href && URL.revokeObjectURL(styleElement.href);
        }) : (styleElement = createStyleElement(options), update = applyToTag.bind(null, styleElement), 
        remove = function() {
            removeStyleElement(styleElement);
        });
        return update(obj), function(newObj) {
            if (newObj) {
                if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap) return;
                update(obj = newObj);
            } else remove();
        };
    }
    function applyToSingletonTag(styleElement, index, remove, obj) {
        var css = remove ? "" : obj.css;
        if (styleElement.styleSheet) styleElement.styleSheet.cssText = replaceText(index, css); else {
            var cssNode = document.createTextNode(css), childNodes = styleElement.childNodes;
            childNodes[index] && styleElement.removeChild(childNodes[index]), childNodes.length ? styleElement.insertBefore(cssNode, childNodes[index]) : styleElement.appendChild(cssNode);
        }
    }
    function applyToTag(styleElement, obj) {
        var css = obj.css, media = obj.media;
        if (media && styleElement.setAttribute("media", media), styleElement.styleSheet) styleElement.styleSheet.cssText = css; else {
            for (;styleElement.firstChild; ) styleElement.removeChild(styleElement.firstChild);
            styleElement.appendChild(document.createTextNode(css));
        }
    }
    function updateLink(linkElement, obj) {
        var css = obj.css, sourceMap = obj.sourceMap;
        sourceMap && (// http://stackoverflow.com/a/26603875
        css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */");
        var blob = new Blob([ css ], {
            type: "text/css"
        }), oldSrc = linkElement.href;
        linkElement.href = URL.createObjectURL(blob), oldSrc && URL.revokeObjectURL(oldSrc);
    }
    /*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
    var stylesInDom = {}, memoize = function(fn) {
        var memo;
        return function() {
            return "undefined" == typeof memo && (memo = fn.apply(this, arguments)), memo;
        };
    }, isOldIE = memoize(function() {
        return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
    }), getHeadElement = memoize(function() {
        return document.head || document.getElementsByTagName("head")[0];
    }), singletonElement = null, singletonCounter = 0, styleElementsInsertedAtTop = [];
    module.exports = function(list, options) {
        options = options || {}, // Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
        // tags it will allow on a page
        "undefined" == typeof options.singleton && (options.singleton = isOldIE()), // By default, add <style> tags to the bottom of <head>.
        "undefined" == typeof options.insertAt && (options.insertAt = "bottom");
        var styles = listToStyles(list);
        return addStylesToDom(styles, options), function(newList) {
            for (var mayRemove = [], i = 0; i < styles.length; i++) {
                var item = styles[i], domStyle = stylesInDom[item.id];
                domStyle.refs--, mayRemove.push(domStyle);
            }
            if (newList) {
                var newStyles = listToStyles(newList);
                addStylesToDom(newStyles, options);
            }
            for (var i = 0; i < mayRemove.length; i++) {
                var domStyle = mayRemove[i];
                if (0 === domStyle.refs) {
                    for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();
                    delete stylesInDom[domStyle.id];
                }
            }
        };
    };
    var replaceText = function() {
        var textStore = [];
        return function(index, replacement) {
            return textStore[index] = replacement, textStore.filter(Boolean).join("\n");
        };
    }();
}, /* 18 */
/***/
function(module, exports) {
    module.exports = require("@atlaskit/layer");
}, /* 19 */
/***/
function(module, exports) {
    module.exports = require("@atlaskit/droplist-trigger");
}, /* 20 */
/***/
function(module, exports) {
    module.exports = require("classnames");
} ]);


//////////////////
// WEBPACK FOOTER
// /opt/atlassian/pipelines/agent/build/~/@atlaskit/droplist/dist/bundle-cjs.js
// module id = 289
// module chunks = 0